import { Pipe, PipeTransform } from '@angular/core';
import { PUBLISH_RATE } from '../constants/global-constants';

@Pipe({
  name: 'publishRateDisplay',
  pure : false
})
export class PublishRateDisplay implements PipeTransform {

  transform( stringValue:number): any {
    let obj = PUBLISH_RATE.find (res => res.secondsValue === stringValue);

    return obj?.rate ? obj.rate : '';
   }
}